import React, { useState, useRef } from "react";
import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@mui/material";
import MultiSelectDropdown from "./common/MultiSelectDropdown";

export default function NotificationModal(props) {
  const titleInputRef = useRef();
  const bodyInputRef = useRef();
  const [selectedVenues, setSelectedVenues] = useState([]);
  const shouldShowVenuesField = !!props.showVenuesField;

  const [state, setState] = useState({});

  const handleConfirm = async () => {
    const validationErrors = {};

    if (!titleInputRef.current.value) {
      validationErrors.title = "Title is required.";
    }

    if (!bodyInputRef.current.value) {
      validationErrors.body = "Body is required.";
    }

    if (shouldShowVenuesField && !selectedVenues.length) {
      validationErrors.venues = "Please select at least one venue.";
    }

    if (Object.keys(validationErrors).length) {
      setState((s) => ({
        ...s,
        errors: validationErrors,
      }));
      return;
    }

    setState((s) => ({
      ...s,
      isLoading: true,
      errors: undefined,
    }));
    const body = {
      userId: props.user.id,
      title: titleInputRef.current.value,
      body: bodyInputRef.current.value,
      ...(shouldShowVenuesField
        ? { venueIds: selectedVenues.map((venue) => venue.id) }
        : {}),
    };
    try {
      await props.handleConfirm(body);
      props.handleClose();
    } catch (error) {
      setState((s) => ({
        ...s,
        isLoading: false,
        errors: {
          submit: error?.message || error || "Failed to send notification.",
        },
      }));
    }
  };

  return (
    <Dialog
      open={true}
      onClose={props.handleClose}
      PaperProps={{
        style: {
          backgroundColor: "#d8c8f4",
          color: "#4b445b",
        },
      }}
    >
      <DialogTitle>Send Custom Notification</DialogTitle>
      <DialogContent>
        <TextField
          autoComplete="off"
          margin="dense"
          id="title"
          label="Title"
          type="text"
          fullWidth
          variant="outlined"
          inputRef={titleInputRef}
          defaultValue={state.title}
          required
          error={!!state.errors?.title}
          helperText={state.errors?.title}
        />
        <TextField
          autoComplete="off"
          margin="dense"
          id="body"
          label="Body"
          type="text"
          fullWidth
          variant="outlined"
          inputRef={bodyInputRef}
          defaultValue={state.body}
          multiline
          rows={6}
          required
          error={!!state.errors?.body}
          helperText={state.errors?.body}
        />
        {shouldShowVenuesField && (
          <>
            <MultiSelectDropdown
              id="notification-venues"
              label="Venues"
              options={props.venueOptions || []}
              value={selectedVenues}
              onChange={setSelectedVenues}
              placeholder="Select one or more venues"
              closeOnSelect
            />
            {!!state.errors?.venues && (
              <Typography variant="caption" color="error" sx={{ display: "block", marginTop: 1 }}>
                {state.errors.venues}
              </Typography>
            )}
          </>
        )}
        {!!state.errors?.submit && (
          <Typography variant="body2" color="error" sx={{ marginTop: 1 }}>
            {state.errors.submit}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleClose} variant="contained">
          Cancel
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          disabled={state.isLoading}
        >
          Send
        </Button>
      </DialogActions>
    </Dialog>
  );
}
